import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import BaseLayout from './../../templates/base';
import Loading from './../../elements/loading';
import InmPagination from "../../elements/widgets/inmPagination";
import {confirmAlert} from "react-confirm-alert";
import _ from 'lodash';
import ConceptsAdd from './../../elements/concepts/widget/concepts_add';
import ConceptsSearch from './../../elements/concepts/widget/concepts_search';

class Concepts extends Component {
	render(){
		return(
			<ConceptsList {...this.props}/>
		);
	}

	componentWillMount(){
		const { concepts } = this.props;
		this.props.conceptsShow(concepts.pages.current,concepts.filters);
	}
}

export class ConceptsList extends Component{
	render() {
		const { concepts } = this.props;
		const { isFetching, pages, list, permissions } = concepts;
		let cu = _.find(permissions, (o) => {return o==='Update'});
		let cd = _.find(permissions, (o) => {return o==='Delete'});
		return (
			<div>
				{isFetching ? <Loading /> :
					[<table className={`inm-table`} key="concepts-table">
						<thead>
						<tr>
							<th>ID</th>
							<th>Actividad</th>
							<th>Estatus</th>
						</tr>
						</thead>
						<tbody>
						{list.map((row, k) => {
							return (
								<tr key={k}>
									<td style={{width:10+'%'}}>
										<div className="actions">
											{cu ? <NavLink to={`/gastos/conceptos/editar/${row.id}`}><i className="fa fa-edit"></i></NavLink>:''}
											{cd ? <button onClick={() => this._getConfirm(row.id, row.name)}><i className="fa fa-trash-o"></i></button>:''}
										</div>
										{row.id}
									</td>
									<td style={{width:50+'%'}}><strong>{row.name}</strong></td>
									<td>
										<strong className={`has-text-${row.status.style}`}>
											{row.status.name}
										</strong>
									</td>
								</tr>
							)
						})}
						</tbody>
					</table>,
				pages.total > 20 &&
					<InmPagination key="concepts-pages" current={pages.current} total={pages.total} nextPage={this._handlePageChange}
					/>
				]}
			</div>
		)
	}

	constructor() {
		super();
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	_conceptDelete(id){
		this.props.deleteConcept(id);
	}

	_handlePageChange(value) {
		const { concepts } = this.props;
		this.props.conceptsShow(value, concepts.filters);
	}

	_getConfirm(id, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar el concepto "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this._conceptDelete(id)
		})
	}
}

//export default BaseLayout(Concepts, {title: `Conceptos de Gastos`, subnav: {icon: 'fa-list-alt', name: 'Administración', actions: {url: '/gastos/conceptos/crear', name: 'Agregar Concepto'}}});
export default BaseLayout(Concepts, {
	title: `Conceptos de Gastos`,
	subnav: {
		icon: 'fa-list-alt',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Buscar',
				element: <ConceptsSearch />
			},
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <ConceptsAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/concepts/index.jsx